<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="epi"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span aria-label="ix" id="pg_ix" role="doc-pagebreak">“Who shot him?”</span></p>
<p class="FM-Epigraph-non-verse-fmepi1">“Somebody with a gun.”</p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-I">—</span>DASHIELL HAMMETT, <span class="ePub-I">RED HARVEST</span></p>
<p class="FM-Epigraph-non-verse-fmepi1"> </p>
<p class="FM-Epigraph-non-verse-fmepi1"> </p>
<p class="FM-Epigraph-non-verse-fmepi1">“Remember, children, <span class="ePub-I">crime does not pay</span>. Not like it used to.”</p>
<p class="FM-Epigraph-Source-fmeps">—JOE E. LEWIS, COMEDIAN</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?76d4a739